import styled from "@emotion/styled";

export const PageScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: ${(p) => p.theme.colors.background};
`;
